export const family = {
    neueSingular: {
        standard: 'Neue-Singular-D-Regular',
    },
};
export const weight = {
    regular: 400,
    bold: 700,
};
